
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 396.667 396.667"}},[_c('path',{attrs:{"d":"M17 87.833h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17zm0 127.5h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17zm0 127.5h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17z"}})])
      }
    
      }
    